import styled from 'styled-components';
import Colors from 'assets/Colors';

const Container = styled.div`
  height: 242px;
  /* width: 100%; */
  padding: 27px 9px 50px 11px;
  width: 100%;
  background: ${Colors.background_secondary};
  overflow: hidden;
  border-radius: 6px;
  box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.06);
  max-width: 100vw;
  margin-bottom: 36px;
  @media (min-width: 1390px) {
    max-width: calc(50% - 22px);
  }
`;

const Title = styled.div`
  font-style: normal;
  letter-spacing: 0.01em;
  color: ${Colors.text_on_primary};
  margin: -27px -9px 27px -11px;
  font-weight: 500;
  font-size: 15px;
  line-height: 18px;
  display: flex;
  justify-content: space-between;
  padding-right: 31px;
  padding-left: 17px;
  background: ${Colors.BG_Header_Card};
  height: 42px;
  align-items: center;
`;

export default {
  Container,
  Title,
};
